import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import arrowIcon from '../../public/arrow-icon.svg';
import style from './style.module.scss';

interface BackButtonProps {
  link: string;
}
export const BackButton = ({ link }: BackButtonProps) => {
  return (
    <Link className={style.link} href={link}>
      <Image width={18} height={18} src={arrowIcon} alt="Назад" />
      <p>Назад</p>
    </Link>
  );
};
